import { defineStore } from "pinia";
import { Toast } from "@/models/ui/toast";
import { ref } from "vue";
import { AxiosError } from "axios";

export const useUiStore = defineStore("ui", () => {
  const isLoading = ref(false);
  const lastTankId = ref<number | null>(null);
  const lastReceiptPlanId = ref<number | null>(null);
  const lastPipelineProduct = ref<number | null>(null);
  const terminalOperationId = ref<number | null>(null);
  const drawer = ref(true);
  const rail = ref(true);
  const toasts = ref<Toast[]>([]);

  function addErrorToast(id: string, message: string, error: unknown) {
    // if the toast is for a 400 response from the api
    if (
      error instanceof AxiosError &&
      error.response &&
      error.response.status === 400 &&
      error.response.data
    ) {
      // overwrite the text with the response error message
      let exception = error.response.data.exception;
      if (!exception) {
        // if no exception object is present, then the exception
        // probably didn't come from fluent val
        exception = error.response.data;
      }

      if (exception) {
        // check if the error message is an array or single string
        if (Array.isArray(exception)) {
          message = exception.map((ex) => ex.errorMessage).join();
        } else {
          message = exception;
        }
      }
    }

    toasts.value.push({
      id: id,
      message: message,
      type: "error",
      isVisible: true,
    });
  }

  function addToast(
    id: string,
    message: string,
    type: string = "regular",
    error: unknown | null = null,
  ) {
    // if an error was passed
    if (error) {
      addErrorToast(id, message, error);
      return;
    }

    toasts.value.push({
      id: id,
      message: message,
      type: type,
      isVisible: true,
    });
  }

  function removeToastById(idToRemove: string) {
    toasts.value = toasts.value.filter((toast) => {
      return idToRemove !== toast.id;
    });
  }

  return {
    isLoading,
    lastTankId,
    lastReceiptPlanId,
    lastPipelineProduct,
    terminalOperationId,
    drawer,
    rail,
    toasts,

    addToast,
    addErrorToast,
    removeToastById,
  };
});
